var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.facebookCampaign)?_c('div',[_c('div',{staticClass:"flex justify-between"},[_c('span',{class:{
        'inline-block': true,
        'bg-gray-200': true,
        'px-3': true,
        'py-1': true,
        'leading-snug': true,
        rounded: true,
        'text-xs': true,
        'text-gray-900': true,
        capitalize: true,
        'font-medium': true,
        'select-none': true,
        'mb-2': true,
      }},[_vm._v(" Facebook Campaign ")]),_c('span',{class:{
        'inline-block': true,
        'bg-green-200': _vm.facebookCampaign.status === 'ACTIVE',
        'bg-gray-200': _vm.facebookCampaign.status !== 'ACTIVE',
        'px-3': true,
        'py-1': true,
        'leading-snug': true,
        rounded: true,
        'text-xs': true,
        'text-green-900': _vm.facebookCampaign.status === 'ACTIVE',
        'text-gray-900': _vm.facebookCampaign.status !== 'ACTIVE',
        capitalize: true,
        'font-medium': true,
        'select-none': true,
        'mb-2': true,
      }},[_vm._v(" "+_vm._s(_vm.facebookCampaign.status)+" ")])]),_c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"block font-medium text-sm capitalize text-gray-600"},[_vm._v("Καμπάνια")]),_vm._v(" "+_vm._s(_vm.facebookCampaign.name)+" ")]),_c('div',{staticClass:"mt-4"},[_c('ul',[_c('li',{staticClass:"flex justify-between"},[_c('span',{staticClass:"block font-medium text-sm capitalize text-gray-600"},[_vm._v("Immpressions")]),_vm._v(" "+_vm._s(_vm.impressions)+" ")]),_c('li',{staticClass:"flex justify-between mt-2"},[_c('span',{staticClass:"block font-medium text-sm capitalize text-gray-600"},[_vm._v("Reach")]),_vm._v(" "+_vm._s(_vm.reach)+" ")]),_c('li',{staticClass:"flex justify-between mt-2"},[_c('span',{staticClass:"block font-medium text-sm capitalize text-gray-600"},[_vm._v("Frequency")]),_vm._v(" "+_vm._s(_vm.frequency)+" ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }